import { useState, useEffect } from "react";
import { Flex, Input, Text } from "@chakra-ui/react";

interface InputProps {
  topLabel?: string;
  leftLabel?: string;
  isTransferTime?: boolean;
  isPercentage?: boolean;
  isLimit?: boolean;
  width?: string;
  height?: string;
  value?: any;
  fontSize?: string;
  isDisabled?: boolean;
  onChange?: (value: string) => void;
  onEdit?: boolean;
}

export default function InputComponent({
  onChange,
  isDisabled,
  topLabel,
  isTransferTime,
  isPercentage,
  isLimit,
  leftLabel,
  height,
  width,
  value,
  fontSize,
  onEdit,
  ...rest
}: InputProps) {
  const [formattedValue, setFormattedValue] = useState<string>("");
  const [oldValue, setOldValue] = useState<string>("");
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;

    inputValue = inputValue.replace(/[a-zA-Z]/g, "");

    if (isPercentage) {
      inputValue = inputValue.replace("%", "");
      if (Number(inputValue) > 100) {
        inputValue = "100";
      }
    } else if (isLimit) {
      let onlyNumbers = inputValue.replace(/\D/g, "");
      if (onlyNumbers === "") {
        return "R$ 0,00";
      }
      const valueInCents = Number(onlyNumbers);
      const valueInReais = valueInCents / 100;
      let formattedValue = valueInReais.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      if (valueInCents >= 1000) {
        formattedValue = formattedValue.replace("R$ 0", "R$ ");
      }
      inputValue = formattedValue;
    } else if (isTransferTime) {
      inputValue = inputValue.replace(/[^\d]/g, "");
    }

    setFormattedValue(inputValue);
    // onChange?.(inputValue);
  };


  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;
    if (isPercentage && inputValue !== "" && !inputValue.includes("%")) {
      inputValue += "%";
    }
    setFormattedValue(inputValue);
    onChange?.(inputValue);
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    if (isPercentage && e.target.value.includes("%")) {
      e.target.value = e.target.value.replace("%", "");
    }
  };

  const maxLength = () => {
    if (isTransferTime) return 2;
    if (isPercentage) return 5;
    if (isLimit) return 15;
  };





  useEffect(() => {
    if (isPercentage) {
      let newValue = value.toString();
      newValue = newValue.replace("%", "");
      if (!newValue.includes("%")) {
        newValue += "%";
      }
      setOldValue(newValue);

    }
    else if (isLimit) {
      let newValue = value
      setOldValue(newValue.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }));
    }
    else if (isTransferTime) {
      let newValue = value.toString();
      setOldValue(newValue);
    }
    //eslint-disable-next-line
  }, [isPercentage, isLimit, isTransferTime]);


  useEffect(() => {
    if (value !== undefined && value !== null) {
      let newValue = value.toString();
      if (isPercentage === true) {
        newValue = newValue.replace("R$", "").replace("%", "").replace(" ", "");
        if (newValue.length >= 7) {
          newValue = "100"
        }
        if (!newValue.includes("%")) {
          newValue += "%";
        }
        setFormattedValue(newValue);
        onChange?.(newValue);

      } else if (isLimit === true) {
        newValue = newValue.replace("R$", "").replace("%", "").replace(" ", "").replace(",", ".");

        let numericValue = String(value)
          .replace("%", "")
          .replace("R$", "")
          .replace(",", ".")
          .trim();

        let parsedValue = parseFloat(numericValue);

        if (!isNaN(parsedValue)) {
          newValue = parsedValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
          });
          setFormattedValue(newValue);
          onChange?.(newValue);
        }
      } else if (isTransferTime) {
       newValue = value.toString();
      }
      setFormattedValue(newValue);
    }
    //eslint-disable-next-line
  }, [isPercentage, isLimit, isTransferTime]);





  return (
    <Flex flexDirection="column">
      <Text fontSize="12px" color="rgba(138, 148, 168, 1)" marginLeft="6px"> {topLabel}</Text>
      <Flex alignItems="center" alignContent="center" gap="8px">
        {leftLabel && <Text color="#8A94A8" fontSize="16px" lineHeight="26px" fontWeight={400}>{leftLabel}</Text>}
        <Input
          {...rest}
          borderRadius="4px"
          fontSize={fontSize || "16px"}
          backgroundColor="rgba(237, 241, 247, 1)"
          h={height || "29px"}
          w={width || (leftLabel ? "111px" : "262px")}
          padding={isTransferTime ? "0 0 0 45px" : "6px"}
          maxLength={maxLength()}
          color={oldValue !== formattedValue ? "rgba(212, 136, 6, 1)" : "black"}
          isDisabled={isDisabled || !onEdit}
          value={formattedValue}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
        {isTransferTime && (
          <Text
            position="absolute"
            fontSize="16px"
            color={oldValue !== formattedValue ? "rgba(212, 136, 6, 1)" : "black"}
            opacity={!onEdit ? "0.5" : "1"}
            h="25px"
            marginLeft={leftLabel ? "45px" : "5px"}
            zIndex={2}>
            D +
          </Text>
        )}
      </Flex>
    </Flex>
  );
}
